import { render, staticRenderFns } from "./TeamAvailability.vue?vue&type=template&id=04c58014&scoped=true&"
import script from "./TeamAvailability.vue?vue&type=script&lang=js&"
export * from "./TeamAvailability.vue?vue&type=script&lang=js&"
import style0 from "./TeamAvailability.vue?vue&type=style&index=0&id=04c58014&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c58014",
  null
  
)

export default component.exports